import { Icon } from "semantic-ui-react";
import { capitalizeFirstLetter } from "utils/stringUtils";
import type { ScheduledSendSessions } from "features/Library/Communications/Emails/types/state";
import {
  type EmailSendSession,
  EmailStatusToColor,
  EmailStatusToIcon,
  EmailStatusToString,
} from "features/Library/Communications/Emails/EmailDetails/Performance/types";

export const showStatus = (entity: EmailSendSession | ScheduledSendSessions) => {
  const status = capitalizeFirstLetter(entity.Status) as keyof typeof EmailStatusToColor;
  return (
    <div className="status">
      <Icon name={EmailStatusToIcon[status]} className={EmailStatusToColor[status]} />
      &nbsp;
      {EmailStatusToString[status]}
    </div>
  );
};
